import React from "react";
import { ArrowUpRight, Pencil, Trash2 } from "lucide-react";
import { toExternalUrl, toTechList } from "../utils/links";

// One project as an editorial row: name and links on the left, what it is and
// what it's built with on the right. Used on Home (featured) and Projects.
const ProjectRow = ({ project, onEdit, onDelete, titleAs: Title = "h3" }) => {
  const tech = toTechList(project.tech);
  const codeUrl = toExternalUrl(project.githubUrl);
  const demoUrl = toExternalUrl(project.liveUrl);

  return (
    <article className="grid gap-4 py-8 md:grid-cols-12 md:gap-8">
      <div className="min-w-0 md:col-span-5">
        <div className="flex items-start justify-between gap-4">
          <Title className="break-words text-xl font-semibold tracking-tight text-slate-50 md:text-2xl">
            {project.title || "Untitled project"}
          </Title>
          {(onEdit || onDelete) && (
            <div className="flex gap-2">
              {onEdit && (
                <button type="button" onClick={() => onEdit(project)} className="icon-btn" title="Edit Project" aria-label="Edit project">
                  <Pencil size={16} strokeWidth={1.75} />
                </button>
              )}
              {onDelete && (
                <button type="button" onClick={() => onDelete(project.id)} className="icon-btn-danger" title="Delete Project" aria-label="Delete project">
                  <Trash2 size={16} strokeWidth={1.75} />
                </button>
              )}
            </div>
          )}
        </div>
        {(codeUrl || demoUrl) && (
          <div className="mt-3 flex flex-wrap gap-x-6 gap-y-2 text-sm">
            {codeUrl && (
              <a href={codeUrl} target="_blank" rel="noopener noreferrer" className="text-link">
                View Code
                <ArrowUpRight size={16} strokeWidth={1.75} />
              </a>
            )}
            {demoUrl && (
              <a href={demoUrl} target="_blank" rel="noopener noreferrer" className="text-link">
                Live Demo
                <ArrowUpRight size={16} strokeWidth={1.75} />
              </a>
            )}
          </div>
        )}
      </div>

      <div className="min-w-0 md:col-span-7">
        {project.description && (
          <p className="max-w-[65ch] break-words leading-relaxed text-slate-300">
            {project.description}
          </p>
        )}
        {tech.length > 0 && (
          <ul className="mt-4 flex flex-wrap gap-x-4 gap-y-1 font-mono text-xs text-slate-400" aria-label="Built with">
            {tech.map((item, i) => (
              <li key={i} className="break-all">{item}</li>
            ))}
          </ul>
        )}
      </div>
    </article>
  );
};

export default ProjectRow;
